(function () {
  "use strict";

  /* ================= Sticky-header suppression while any drawer is open =================
     Drawer aur cart dono is helper ko call karte hain. Jab tak ek bhi khula hai,
     body par "ch-menu-open" class lagi rahegi jo CSS mein sticky header ko force-off karti hai. */
  function syncMenuOpenClass() {
    var anyOpen =
      (drawer && drawer.classList.contains("is-open")) ||
      (cartDrawer && cartDrawer.classList.contains("is-open"));
    document.body.classList.toggle("ch-menu-open", !!anyOpen);
  }

  /* ================= Side drawer (hamburger menu) ================= */
  var drawer = document.querySelector("[data-drawer]");
  var drawerOverlay = document.querySelector("[data-drawer-overlay]");
  /* =========================================================
   MOVE DRAWER TO BODY
   This completely removes Shopify/theme stacking-context
   problems caused by section/header parents.
   ========================================================= */

if (drawer && drawer.parentElement !== document.body) {
  document.body.appendChild(drawer);
}

if (drawerOverlay && drawerOverlay.parentElement !== document.body) {
  document.body.appendChild(drawerOverlay);
}

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawerOverlay.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    syncMenuOpenClass();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawerOverlay.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    syncMenuOpenClass();
  }
  document.querySelectorAll(".ch-drawer-open").forEach(function (b) { b.addEventListener("click", openDrawer); });
  document.querySelectorAll("[data-drawer-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
  if (drawerOverlay) drawerOverlay.addEventListener("click", closeDrawer);

  /* ================= Mobile search overlay ================= */
  var searchMobile = document.querySelector("[data-search-mobile]");
  document.querySelectorAll(".ch-search-open").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!searchMobile) return;
      searchMobile.classList.add("is-open");
      var input = searchMobile.querySelector("input[type='search']");
      if (input) input.focus();
    });
  });
  document.querySelectorAll(".ch-search-close").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (searchMobile) searchMobile.classList.remove("is-open");
    });
  });

  /* ================= Account dropdown ================= */
  var accountToggle = document.querySelector("[data-account-toggle]");
  var accountDropdown = document.querySelector("[data-account-dropdown]");
  if (accountToggle && accountDropdown) {
    accountToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      var isOpen = accountDropdown.classList.toggle("is-open");
      accountToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
    document.addEventListener("click", function (e) {
      if (!accountDropdown.contains(e.target) && e.target !== accountToggle) {
        accountDropdown.classList.remove("is-open");
        accountToggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    closeDrawer();
    closeCartDrawer();
    if (accountDropdown) accountDropdown.classList.remove("is-open");
  });

  /* ================= Wishlist (localStorage) ================= */
  var WISHLIST_KEY = "shopnukkad_wishlist";

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateWishlistBadges();
    document.dispatchEvent(new CustomEvent("wishlist:updated", { detail: { list: list } }));
  }
  function updateWishlistBadges() {
    var count = getWishlist().length;
    document.querySelectorAll("[data-wishlist-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  window.ShopNukkadWishlist = {
    add: function (handle) {
      var list = getWishlist();
      if (list.indexOf(handle) === -1) list.push(handle);
      saveWishlist(list);
    },
    remove: function (handle) {
      saveWishlist(getWishlist().filter(function (h) { return h !== handle; }));
    },
    has: function (handle) { return getWishlist().indexOf(handle) !== -1; },
    toggle: function (handle) {
      this.has(handle) ? this.remove(handle) : this.add(handle);
      return this.has(handle);
    },
    all: getWishlist
  };

  // Bind any heart buttons already on the page (product cards use snippets/wishlist-heart-button.liquid)
  function bindHeartButtons() {
    document.querySelectorAll(".ch-heart-btn[data-product-handle]").forEach(function (btn) {
      var handle = btn.getAttribute("data-product-handle");
      btn.classList.toggle("is-active", window.ShopNukkadWishlist.has(handle));
      if (btn.dataset.bound) return;
      btn.dataset.bound = "true";
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var active = window.ShopNukkadWishlist.toggle(handle);
        btn.classList.toggle("is-active", active);
      });
    });
  }
  bindHeartButtons();
  document.addEventListener("wishlist:updated", bindHeartButtons);

  updateWishlistBadges();

  // Render wishlist grid on the wishlist page (container: [data-wishlist-grid])
  function renderWishlistPage() {
    var grid = document.querySelector("[data-wishlist-grid]");
    if (!grid) return;
    var handles = getWishlist();

    if (handles.length === 0) {
      grid.innerHTML = '<p class="wl-empty">Your wishlist is empty. Tap the heart icon on any product to save it here.</p>';
      return;
    }

    grid.innerHTML = "";
    handles.forEach(function (handle) {
      fetch("/products/" + handle + ".js")
        .then(function (res) { if (!res.ok) throw new Error("not found"); return res.json(); })
        .then(function (product) {
          var price = (product.price / 100).toLocaleString("en-IN", { style: "currency", currency: window.Shopify && Shopify.currency ? Shopify.currency.active : "INR" });
          var card = document.createElement("div");
          card.className = "wl-card";
          card.innerHTML =
            '<a href="/products/' + product.handle + '"><img src="' + (product.featured_image || "") + '" alt="' + product.title + '"></a>' +
            '<div class="wl-card__body">' +
              '<a href="/products/' + product.handle + '" class="wl-card__title">' + product.title + '</a>' +
              '<span class="wl-card__price">' + price + '</span>' +
              '<div class="wl-card__actions">' +
                '<button type="button" class="ch-btn ch-btn--solid" data-wl-add-cart="' + product.variants[0].id + '">Add to cart</button>' +
                '<button type="button" class="ch-btn ch-btn--ghost" data-wl-remove="' + handle + '">Remove</button>' +
              '</div>' +
            '</div>';
          grid.appendChild(card);
        })
        .catch(function () {
          // product handle no longer exists / unpublished - drop it silently
          window.ShopNukkadWishlist.remove(handle);
        });
    });
  }

  document.addEventListener("click", function (e) {
    var removeBtn = e.target.closest("[data-wl-remove]");
    if (removeBtn) {
      window.ShopNukkadWishlist.remove(removeBtn.getAttribute("data-wl-remove"));
      removeBtn.closest(".wl-card").remove();
      var grid = document.querySelector("[data-wishlist-grid]");
      if (grid && getWishlist().length === 0) renderWishlistPage();
    }
    var addBtn = e.target.closest("[data-wl-add-cart]");
    if (addBtn) {
      addToCart(addBtn.getAttribute("data-wl-add-cart"), 1);
    }
  });

  renderWishlistPage();

  /* ================= Cart drawer + AJAX add to cart ================= */
  var cartDrawer = document.querySelector("[data-cart-drawer]");
  var cartOverlay = document.querySelector("[data-cart-overlay]");

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add("is-open");
    cartOverlay.classList.add("is-open");
    cartDrawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    syncMenuOpenClass();
    refreshCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("is-open");
    cartOverlay.classList.remove("is-open");
    cartDrawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    syncMenuOpenClass();
  }
  document.querySelectorAll("[data-cart-toggle]").forEach(function (b) { b.addEventListener("click", openCartDrawer); });
  document.querySelectorAll("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeCartDrawer); });
  if (cartOverlay) cartOverlay.addEventListener("click", closeCartDrawer);

  function moneyFormat(cents) {
    return "₹" + (cents / 100).toLocaleString("en-IN", { minimumFractionDigits: 2 });
  }

  function refreshCartDrawer() {
    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });

        var itemsWrap = document.querySelector("[data-cart-items]");
        var footer = document.querySelector("[data-cart-footer]");
        var subtotalEl = document.querySelector("[data-cart-subtotal]");
        if (!itemsWrap) return;

        if (cart.item_count === 0) {
          itemsWrap.innerHTML = '<p class="ch-cart-empty" data-cart-empty>Your cart is empty.</p>';
          if (footer) footer.hidden = true;
          return;
        }

        if (footer) footer.hidden = false;
        if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);

        itemsWrap.innerHTML = cart.items.map(function (item) {
          return (
            '<div class="ch-cart-item" data-line-key="' + item.key + '">' +
              '<img src="' + (item.image || "") + '" alt="' + item.product_title + '">' +
              '<div class="ch-cart-item__info">' +
                '<span class="ch-cart-item__title">' + item.product_title + '</span>' +
                (item.variant_title ? '<span class="ch-cart-item__meta">' + item.variant_title + '</span>' : '') +
                '<div class="ch-cart-item__row">' +
                  '<div class="ch-cart-item__qty">' +
                    '<button type="button" data-qty-decrease>-</button>' +
                    '<span>' + item.quantity + '</span>' +
                    '<button type="button" data-qty-increase>+</button>' +
                  '</div>' +
                  '<span>' + moneyFormat(item.final_line_price) + '</span>' +
                '</div>' +
                '<a href="#" class="ch-cart-item__remove" data-qty-remove>Remove</a>' +
              '</div>' +
            '</div>'
          );
        }).join("");
      })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var wrap = e.target.closest(".ch-cart-item");
    if (!wrap) return;
    var key = wrap.getAttribute("data-line-key");

    if (e.target.closest("[data-qty-increase]") || e.target.closest("[data-qty-decrease]") || e.target.closest("[data-qty-remove]")) {
      e.preventDefault();
      var currentQtyEl = wrap.querySelector(".ch-cart-item__qty span");
      var currentQty = parseInt(currentQtyEl.textContent, 10) || 0;
      var newQty = currentQty;

      if (e.target.closest("[data-qty-increase]")) newQty = currentQty + 1;
      if (e.target.closest("[data-qty-decrease]")) newQty = Math.max(0, currentQty - 1);
      if (e.target.closest("[data-qty-remove]")) newQty = 0;

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function () { refreshCartDrawer(); })
        .catch(function () {});
    }
  });

  function addToCart(variantId, quantity) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        openCartDrawer();
      })
      .catch(function () {});
  }
  window.ShopNukkadAddToCart = addToCart;

  // Intercept any existing "Add to cart" forms on the site (product page / product cards)
  // so they open the drawer + go straight to checkout flow instead of a full page reload.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch("/cart/add.js", { method: "POST", body: formData })
      .then(function (res) { return res.json(); })
      .then(function () { openCartDrawer(); })
      .catch(function () {});
  });

  document.addEventListener("cart:updated", refreshCartDrawer);
  refreshCartDrawer();
})();
